module.exports = __webpack_public_path__ + "static/scale-model-of-las-olas-beach-in-hollywood-florida-ef88db5d88ae0d4f90f5444b54019da2.png";